function ShareIcon({fillColor="#F9FAFB"}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M9 8.06344C8.62 8.06344 8.28 8.21344 8.02 8.44844L4.455 6.37344C4.48 6.25844 4.5 6.14344 4.5 6.02344C4.5 5.90344 4.48 5.78844 4.455 5.67344L7.98 3.61844C8.25 3.86844 8.605 4.02344 9 4.02344C9.83 4.02344 10.5 3.35344 10.5 2.52344C10.5 1.69344 9.83 1.02344 9 1.02344C8.17 1.02344 7.5 1.69344 7.5 2.52344C7.5 2.64344 7.52 2.75844 7.545 2.87344L4.02 4.92844C3.75 4.67844 3.395 4.52344 3 4.52344C2.17 4.52344 1.5 5.19344 1.5 6.02344C1.5 6.85344 2.17 7.52344 3 7.52344C3.395 7.52344 3.75 7.36844 4.02 7.11844L7.58 9.19844C7.555 9.30344 7.54 9.41344 7.54 9.52344C7.54 10.3284 8.195 10.9834 9 10.9834C9.805 10.9834 10.46 10.3284 10.46 9.52344C10.46 8.71844 9.805 8.06344 9 8.06344Z" fill={fillColor}/>
        </svg>
        
    );
}

export default ShareIcon;
